import React from "react";
import { createDfpAdComponent } from "@quintype/components";
import get from "lodash/get";
import { string } from "prop-types";

const ViewPortSizeMappingHorizontaldefault728x90 = [
  { viewport: [768, 0], sizes: [[728, 90]] },
  { viewport: [300, 0], sizes: [[320, 50]] }
];

const CONFIG = {
  rectangle_0_300x250: {
    adUnit: "rectangle_0_300x250",
    sizes: [[300, 250]]
  },
  rectangle_1_300x250: {
    adUnit: "rectangle_1_300x250",
    sizes: [[300, 250]]
  },
  banner_1_300x100: {
    adUnit: "banner_1_300x100",
    sizes: [[300, 100]]
  },
  banner_2_300x100: {
    adUnit: "banner_2_300x100",
    sizes: [[300, 100]]
  },
  banner_1_728x90: {
    adUnit: "banner_1_728x90",
    sizes: [[320, 50], [728, 90]],
    viewPortSizeMapping: ViewPortSizeMappingHorizontaldefault728x90
  },
  leaderboard_2_728x90: {
    adUnit: "leaderboard_2_728x90",
    sizes: [[320, 50], [728, 90]],
    viewPortSizeMapping: ViewPortSizeMappingHorizontaldefault728x90
  },
  leaderboard_3_728x90: {
    adUnit: "leaderboard_2_728x90",
    sizes: [[320, 50], [728, 90]],
    viewPortSizeMapping: ViewPortSizeMappingHorizontaldefault728x90
  },
  leaderboard_4_728x90: {
    adUnit: "leaderboard_2_728x90",
    sizes: [[320, 50], [728, 90]],
    viewPortSizeMapping: ViewPortSizeMappingHorizontaldefault728x90
  },
  Freepressjournal_300x250_DT_MWeb_Global_STMA: {
    adUnit: "Freepressjournal_300x250_DT_MWeb_Global_STMA",
    sizes: [[300, 250]]
  }
};

const getPageName = state => {
  const pagetype = get(state, ["qt", "pageType"]);
  if (pagetype === "home-page") {
    return "home";
  } else if (pagetype === "section-page") {
    return get(state, ["qt", "data", "collection", "slug"]);
  } else if (pagetype === "story-page") {
    return get(state, ["qt", "data", "story", ["story-template"]]);
  }
};

const getStorySectionName = state => {
  const pagetype = get(state, ["qt", "pageType"]);
  if (pagetype === "story-page") {
    return get(state, ["qt", "data", "story", "sections", 0, "name"]);
  }
};
const DfpAdContentNew = createDfpAdComponent({
  defaultNetworkID: "21751243814",
  config: CONFIG,
  lazyLoad: false,

  targeting: function(state) {
    const params = {
      environment: get(state, ["qt", "config", ["publisher-attributes"], "env"]),
      pageType: get(state, ["qt", "pageType"]),
      publisherName: get(state, ["qt", "config", "publisher-name"]),
      publisherId: get(state, ["qt", "config", "publisher-id"]) || 571,
      pageName: getPageName(state),
      storySection: getStorySectionName(state)
    };
    return params;
  }
});

const DfpAdContent = createDfpAdComponent({
  defaultNetworkID: "102417597",
  config: CONFIG,
  lazyLoad: false,

  targeting: function(state) {
    const params = {
      environment: get(state, ["qt", "config", ["publisher-attributes"], "env"]),
      pageType: get(state, ["qt", "pageType"]),
      publisherName: get(state, ["qt", "config", "publisher-name"]),
      publisherId: get(state, ["qt", "config", "publisher-id"]) || 571,
      pageName: getPageName(state),
      storySection: getStorySectionName(state)
    };
    if (
      get(state, ["qt", "pageType"]) === "story-page" &&
      get(state, ["qt", "data", "story", "metadata", "sponsored-by"])
    ) {
      params.sponsor = get(state, ["qt", "data", "story", "metadata", "sponsored-by"]);
      return params.sponsor;
    }
    return params;
  }
});

const DfpAd = props => {
  return (
    <div>{props.dfpNetworkId === "21751243814" ? <DfpAdContentNew {...props} /> : <DfpAdContent {...props} />}</div>
  );
};

DfpAd.propTypes = {
  dfpNetworkId: string
};

export default DfpAd;
